import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "packageCard",
  type: "object",
  title: "Package Card",
  fields: [
    {
      name: "variant",
      type: "string",
      title: "Header Variant",
      options: {
        list: [
          { title: "Default", value: "default" },
          { title: "VS", value: "vs" }
        ]
      },
      initialValue: "default"
    },
    {
      name: "title",
      type: "multilingualArrayString",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "subtitle",
      type: "multilingualArrayBlockContent",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "content",
      type: "multilingualArrayBlockContent",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "footer",
      type: "multilingualArrayBlockContent",
      options: {
        collapsed: true,
        collapsable: true
      }
    },

    {
      type: "ctaButtons",
      name: "ctaButtons",
      title: "CTA Buttons",
      validation: (Rule) => Rule.max(1),
      options: {
        collapsible: true,
        collapsed: true
      }
    }
  ],
  preview: {
    select: {
      title: "title",
      media: "image"
    },
    prepare({ title, media }) {
      return {
        title: multilingualStringPreview(title),
        media
      };
    }
  }
});
